import Axios, { CancelTokenSource, AxiosRequestConfig } from "axios";

// TODO: acquireTokenSilent every ajax request, do not store it here
export let token: string = "";

export function setToken(t: string) {
    token = t;
}
Axios.interceptors.request.use(function (config) {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function getToken() {
    return token;
}

export class ApiClientBase {
    private baseUrl: string;
    private showDefaultErrorMessage?: boolean;
    constructor(baseUrl: string, useDefaultErrorMessage: boolean = true) {
        this.baseUrl = `${baseUrl}`;
        this.showDefaultErrorMessage = useDefaultErrorMessage;
    }

    private getErrorMessage(error: any): string {
        const msg =
            error.response.data.exceptionMessage !== undefined ? error.response.data.exceptionMessage : error.message;
        return msg;
    }

    protected getParametersString(object: any): string {
        const str = Object.keys(object)
            .map((key) => {
                const value = object[key] instanceof Date ? object[key].toISOString() : object[key];
                return `${key}=${value}`;
            })
            .join("&");
        return str;
    }

    protected async request<TResult>(
        config: AxiosRequestConfig,
        disableUnauthorizedRedirection?: boolean
    ): Promise<TResult> {
        try {
            const response = await Axios.request(config);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    protected async get<T>(url: string): Promise<T> {
        return this.request({ url: this.buildUrl(url), method: "GET" });
    }

    protected post<TResult, TData>(url: string, data?: TData): Promise<TResult> {
        return this.request({ url: this.buildUrl(url), method: "POST", data: data });
    }

    protected buildUrl = (url: string) => this.baseUrl + url;
}

export function isCancel(error: any) {
    return Axios.isCancel(error);
}

export function getCancelTockenSource(): CancelTokenSource {
    return Axios.CancelToken.source();
}

export function StoreErrorHandler(e: { httpStatus?: number; errorDetails?: any; requestOptions?: any }) {
    if (e.httpStatus === 401) {
        document.location.href = "/";
    }
}
